import Blue from "~/core";

new Blue({
	name: 'Product Tags - Remove Filters',
	selector: ".product-tags",
	setup(container) {
		const filterTags = [...container.querySelectorAll(".product-tags__tag")];
		const clearBtn = container.querySelector(".product-tags__tag--clear");

		filterTags.forEach(f => {
			this.$addEvents(f, "click.prevent", () => {
				f.remove();
			});
		});
		this.$addEvents(clearBtn, "click.prevent", () => {
			filterTags.forEach(f => {
				f.remove();
			});
			// Not sure if below will cause problems for blazor templates/logic when new tags are added after clearing all
			// clearBtn.setAttribute("disabled", "disabled")
		});
	}
});
